//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'
export default {
    name: 'index',
    mixins: [SEO,JSONSCHEMA],
    data: () => ({
        page: {},
        active:0,
        formOpenResult:false,
        searchKey:'',
        searchResult:[],
    }),

    methods:{
        async faqSearch() {
            if(this.searchKey.length > 3) {
                const response = await this.$api.faqSearch(this.searchKey)
                this.searchResult = response.content
                this.formOpenResult = true
            }else{
                this.formOpenResult = false
            }
        },

        inputBlur() {
            if(this.searchKey.length > 3) {
                this.formOpenResult = true
            }
        },
    },

    mounted() {
        var _this = this
        document.addEventListener("click", function (event) {
            var searchTrigger = document.getElementsByClassName('form-contain')[0];
            if(searchTrigger) {
                if (!searchTrigger.contains(event.target)) {
                    _this.formOpenResult = false
                    _this.searchKey = ''
                }
            }
        })
    },

  async asyncData({ $api, $toast }) {
    try {
      const response = await $api.fetchFaqs()
      return { page: response.content }
    } catch (error) {
      $toast.error(error.response.data.message)
    }
  }

}
